import { c as _c } from "react/compiler-runtime";
import { forwardRef } from 'react';
import { type UserMessage } from '../types';
import { StyledGridMessageCardContainer, StyledGridMessageAvatarContainer, StyledGridMessageCardContent, StyledSpanMessageAuthorName, StyledSpanCreatedAtDetails } from '../styles';
import Typography from '../../../Typography';
interface UserMessageCardProps {
  message: UserMessage;
}
const UserMessageCard = forwardRef<HTMLDivElement, UserMessageCardProps>((t0, ref) => {
  const $ = _c(22);
  const {
    message
  } = t0;
  const isCurrentUser = message.isCurrentUser ?? false;
  const messageAuthorName = isCurrentUser ? "You" : message.createdBy.name;
  let t1;
  if ($[0] !== message.createdBy.avatar) {
    t1 = <StyledGridMessageAvatarContainer>{message.createdBy.avatar}</StyledGridMessageAvatarContainer>;
    $[0] = message.createdBy.avatar;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = message.createdBy.onClick != null;
  let t3;
  if ($[2] !== isCurrentUser || $[3] !== message.createdBy.onClick || $[4] !== messageAuthorName || $[5] !== t2) {
    t3 = <StyledSpanMessageAuthorName $isClickable={t2} onClick={message.createdBy.onClick} $isCurrentUser={isCurrentUser}>{messageAuthorName}</StyledSpanMessageAuthorName>;
    $[2] = isCurrentUser;
    $[3] = message.createdBy.onClick;
    $[4] = messageAuthorName;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== message.createdAtString) {
    t4 = <StyledSpanCreatedAtDetails> • {message.createdAtString}</StyledSpanCreatedAtDetails>;
    $[7] = message.createdAtString;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <Typography variant="body3">{t3}{t4}</Typography>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isCurrentUser || $[13] !== message.content || $[14] !== message.isInternal || $[15] !== t5) {
    t6 = <StyledGridMessageCardContent $isCurrentUser={isCurrentUser} $isInternal={message.isInternal}>{t5}{message.content}</StyledGridMessageCardContent>;
    $[12] = isCurrentUser;
    $[13] = message.content;
    $[14] = message.isInternal;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== isCurrentUser || $[18] !== ref || $[19] !== t1 || $[20] !== t6) {
    t7 = <StyledGridMessageCardContainer ref={ref} $isCurrentUser={isCurrentUser}>{t1}{t6}</StyledGridMessageCardContainer>;
    $[17] = isCurrentUser;
    $[18] = ref;
    $[19] = t1;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
});
export default UserMessageCard;